var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"width":"50pt","height":"50pt"},attrs:{"src":require("../../../../assets/images/logo_square_1.jpeg")}})
}
var staticRenderFns = []

export { render, staticRenderFns }